import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { f as i } from "../internals/fails.js";
import { t as n } from "../internals/this-number-value.js";
var o = t(1..toPrecision);
r({
  target: "Number",
  proto: !0,
  forced: i(function () {
    return "1" !== o(1, void 0);
  }) || !i(function () {
    o({});
  })
}, {
  toPrecision: function toPrecision(r) {
    return void 0 === r ? o(n(this)) : o(n(this), r);
  }
});